export const GQL_ENDPOINT = window.location.hostname.includes("attributeanalytics.com")  ? "https://aa-beta-api.devlab.zone/api/graphql" : window.location.hostname.includes("webflow.io") ? "https://aa-dev-api.devlab.zone/api/graphql" : "http://localhost:4090/api/graphql"
export const API_ENDPOINT = window.location.hostname.includes("attributeanalytics.com")  ? "https://aa-beta-api.devlab.zone" : window.location.hostname.includes("webflow.io") ? "https://aa-dev-api.devlab.zone" : "http://localhost:4090"
export const S3_BASE_URL = window.location.hostname.includes("attributeanalytics.com")  ? "https://attribute-analytics-mvp-dev.s3.amazonaws.com/" : "https://attribute-analytics-mvp-dev.s3.amazonaws.com/";

export const CLIENT_URL = window.location.hostname.includes("attributeanalytics.com") ? "https://beta.attributeanalytics.com" : window.location.hostname.includes("devlab.zone") ? `https://aa-dev.devlab.zone`: window.location.hostname.includes("webflow.io") ? `https://aa-mvp.webflow.io` : "http://localhost:3090";

const isProd = window.location.hostname.includes("attributeanalytics.com");

export const PUBLIC_PATHS = {
    dashboard: "",
    categories: "/categories/(.*)",
    products: "/products/(.*)",
    innovationPortfolioDetails: "/innovation/product-portfolio-innovation-details",
    innovationPortfolio: "/product-portfolio-innovation/(.*)",
    innovationEngine: "/innovation/innovation-engine",
    innovationCategory: "/innovation/innovation-category",
    innovationFlavour: "/innovation/innovation-flavor",
    settings: "/settings",
    explore: "/explore",
    tempPage: "/dev/product-portfolio-innovation-details",
};

export const CATEGORY_STRIPE_MAPPING = [
    {
        name: "Canned Fish",
        priceId: isProd ? "price_1QDSifRxV6EVsiXAy2gz5qRv" : "price_1Pyf7wRxV6EVsiXAqTtKnN9Q"
    },
    {
        name: "Canned Tomatoes",
        priceId: isProd ? "price_1QDSihRxV6EVsiXA7IxIdgqy" : "price_1Pyf7eRxV6EVsiXAq0bIbTjc"
    },
    {
        name: "Canned Beans",
        priceId: isProd ? "price_1QDSijRxV6EVsiXAaSV3bRrH" : "price_1Pyf7GRxV6EVsiXAsuWLvzoY"
    },
    {
        name: "Canned Vegetables",
        priceId: isProd ? "price_1QDSilRxV6EVsiXAqsxphzoV" : "price_1Pyf6rRxV6EVsiXAj27CHEcS"
    },
    {
        name: "Soups",
        priceId: isProd ? "price_1QDSjcRxV6EVsiXA8t4GIGSi" : "price_1Pyf6TRxV6EVsiXAKSrEKkGD"
    },
    {
        name: "Sliced Packaged Bread",
        priceId: isProd ? "price_1QDSjeRxV6EVsiXAbkplOKcM" : "price_1Pyf6CRxV6EVsiXA7flOsSpC"
    },
    {
        name: "Soda",
        priceId: isProd ? "price_1QDSjgRxV6EVsiXA1ehzyuMp" : "price_1Pyf5mRxV6EVsiXABL2XXEl4"
    },
    {
        name: isProd ? "Juices Category Intelligence" : "Juices",
        priceId: isProd ? "price_1S7i63RxV6EVsiXADXiNx38d" : "price_1Pyf5YRxV6EVsiXAkOa7p7Eb"
    },
    {
        name: isProd ? "Water Category Intelligence" : "Water",
        priceId: isProd ? "price_1QDSjkRxV6EVsiXAZOg2ynWp" : "price_1Pyf5IRxV6EVsiXAhbaKT32F"
    },
    {
        name: isProd ? "Packaged Dinner Mixes Category Intelligence" : "Packaged Dinner Mixes",
        priceId: isProd ? "price_1QDSjnRxV6EVsiXAVrDdEO04" : "price_1Pyf50RxV6EVsiXAMToDm9WZ"
    },
    {
        name: isProd ? "Non-Chocolate Candy Category Intelligence" : "Non-Chocolate Candy",
        priceId: isProd ? "price_1QDSjpRxV6EVsiXAXZRS2dkJ" : "price_1Pyf3YRxV6EVsiXAYHoCkoc6"
    },
    {
        name: "Chocolate Candy",
        priceId: isProd ? "price_1QDSjrRxV6EVsiXAeM24QzDp" : "price_1Pyf2aRxV6EVsiXA4AF15PWm"
    },
    {
        name: isProd ? "Nuts Category Intelligence" : "Nuts",
        priceId: isProd ? "price_1QDSjsRxV6EVsiXApLUlSJWw" : "price_1Pyf1zRxV6EVsiXAEvk5JQ2h"
    },
    {
        name: isProd ? "Tortilla Chips Category Intelligence" : "Tortilla Chips",
        priceId: isProd ? "price_1QDSjvRxV6EVsiXAHOTthPvE" : "price_1Pyf1jRxV6EVsiXAOViEN2x7"
    },
    {
        name: isProd ? "Potato Chips Category Intelligence" : "Potato Chips",
        priceId: isProd ? "price_1QDSjxRxV6EVsiXAARCeNtwS" : "price_1Pyf1PRxV6EVsiXAiuykMmd1"
    },
    {
        name: "Cookies",
        priceId: isProd ? "price_1QDSjyRxV6EVsiXAZ8cfXEsL" : "price_1Pyf0rRxV6EVsiXAT9LTShWS"
    },
    {
        name: "Crackers",
        priceId: isProd ? "price_1QDSk0RxV6EVsiXATzUta2ya" : "price_1Pyf0cRxV6EVsiXA3ubIwcPp"
    },
    {
        name: "Breakfast Cereal",
        priceId: isProd ? "price_1QDSk2RxV6EVsiXA3xtPb9H3" : "price_1Pyf0HRxV6EVsiXAV4iOYO9K"
    },
    {
        name: isProd ? "Dairy Milk Beverages Category Intelligence" : "Dairy Milk Beverages",
        priceId: isProd ? "price_1QDSk5RxV6EVsiXAcZIlhnS6" : "price_1PyezmRxV6EVsiXAOf0lunJV"
    },
    {
        name: isProd ? "Non-Dairy Milk Beverages Category Intelligence" : "Non-Dairy Milk Beverages",
        priceId: isProd ? "price_1QDShqRxV6EVsiXACVSnyjuT" : "price_1PyezSRxV6EVsiXAXeGoSqbk"
    },
    {
        name: "Dairy Cheese",
        priceId: isProd ? "price_1QDShnRxV6EVsiXADvWfmYGu" : "price_1Pyez0RxV6EVsiXA6PH45cth"
    },
    {
        name: "Non-Dairy Cheese",
        priceId: isProd ? "price_1QDShlRxV6EVsiXAr6e2y1mr" : "price_1Pyey1RxV6EVsiXAptMwe0VL"
    },
    {
        name: "Dairy Yogurt",
        priceId: isProd ? "price_1QDShiRxV6EVsiXAOneHAs2t" : "price_1PyexfRxV6EVsiXARuZhyZwa"
    },
    {
        name: "Non-Dairy Yogurt",
        priceId: isProd ? "price_1QDShfRxV6EVsiXAo6os1CzL" : "price_1PyexIRxV6EVsiXAEwadIbEw"
    },
    {
        name: "Dairy Ice Cream",
        priceId: isProd ? "price_1RGoNDRxV6EVsiXAk5XfAIbp" : "price_1Pyev8RxV6EVsiXAUQP1iaIM"
    },
    {
        name: "Non-Dairy Ice Cream",
        priceId: isProd ? "price_1QDShbRxV6EVsiXAPqKwDMRu" : "price_1PyetERxV6EVsiXAXOui0rIf"
    },
    {
        name: "(10) Innovation Engine Credits",
        priceId: isProd ? "price_1QDShYRxV6EVsiXAskzox4J2" : "price_1Q1CfyRxV6EVsiXAsXjzUEh6"
    },
    {
        name: "Coffee",
        priceId: "price_1QtjwRRxV6EVsiXA6E5yKxz0"
    },
    {
        name: "Snack Bars",
        priceId: isProd ? "price_1RJEgnRxV6EVsiXA501rsQqv" : "price_1Pyf7wRxV6EVsiXAqTtKnN9Q"
    },
    {
        name: "Recipe Unlock",
        priceId: isProd ? "price_1RdXrcRxV6EVsiXAYjijykOm" : "price_1RjZydRxV6EVsiXAr6dzvf1a"
    }, {
        name: "Plant-based Milk Beverages Category Intelligence",
        priceId: "price_1QDSk9RxV6EVsiXAlniQHzzh"
    }, {
        name: "Dips",
        priceId: isProd ? "price_1SIFPLRxV6EVsiXAPGpC7p2a" : "price_1SIndFRxV6EVsiXAogpLCMu1"
    }
]

const WORDS_PER_MINUTE = 200;